import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TaskCard from '../components/TaskCard';  // TaskCard importálása
import TaskCardTable from '../components/TaskCardTable';  // TaskCardTable importálása
import useTableTask from "../hooks/useTableTask";  // useTableTask hook importálása
import useTables from '../hooks/useTables';  // useTables hook importálása
import '../css/task.css'
import { Link } from 'react-router-dom';
import NoteBlock from '../components/NoteBlock';
import useTaskFilter from '../hooks/useTaskFilter';
import Store from '../store/Store';
// import TaskFilterBar from '../components/TaskFilterBar';
import TaskFilterOnly from '../components/TaskFilterOnly';
import TaskFilterBar from '../components/TaskFilterBar';

const TableTask = () => {
    let {tasks, user} = Store.getState();

    const {
        table, tasksByTable, relatedParcels, redirectToTable, tableName, navigate, isNebihSendable, statusIcons, isCompleted, taskStates, toggleTaskState, toggleAllTasks, allTasksOpen
    } = useTableTask();  // A hook adatainak kinyerése

    const {
        tableStates, toggleTableState,
    } = useTables();  // A másik hook adatainak kinyerése

    const { 
        searchKey, setSearchKey, isDoneFilter, setIsDoneFilter, order, setOrder, filteredTasks
    } = useTaskFilter(tasks, user);

    const relatedParcelNames = table && relatedParcels(table).map(parcel => parcel.parcel_name).join(", ");

    const goBack = ()=> {
        navigate(-1);
    }

    const renderHead = ()=>{
        return (<div className={"page-head mt-2 mb-3 d-flex"}>
            <h3 className="title"><strong>{!table ? "Összes feladat ("+filteredTasks.length+")" : "Táblacsoport" }</strong></h3>
            <div>
                {/* <Link to={"/"} className={"btn button"}>{"< Vissza"} </Link> */}
                <button onClick={()=>{goBack()}} className={"btn button"}>{"< Vissza"} </button>
            </div>
        </div>);
    }

    const TaskList = ({ tasks, isNebihSendable, statusIcons, isCompleted, tableName, redirectToTable, noResultsMessage, taskStates, toggleTaskState }) => {
        return (
            <Row>
                {tasks.length > 0 ? tasks.map(task => (
                    <TaskCard key={'task_' + task.id} task={task} isNebihSendable={isNebihSendable} statusIcons={statusIcons} isCompleted={isCompleted} tableName={tableName} redirectToTable={redirectToTable} isOpen={taskStates[task.id] !== false} toggleTaskState={toggleTaskState} />
                )) : (
                    <div className="no-results-message">{noResultsMessage}</div>
                )}
            </Row>
    )};

    const ToggleBlock = ({toggleAllTasks,allTasksOpen,filteredTasks}) => {
        return (
            <div className={"page-head mb-3 mt-4 d-flex "}>
                <h4 className="title"><strong>{"Feladatok ("+filteredTasks.length +")"}</strong></h4>
                <button className="btn button" onClick={toggleAllTasks}>
                    {allTasksOpen 
                        ? (<>Összes bezárása <FontAwesomeIcon icon="fa-solid fa-chevron-up" /></>) 
                        : (<>Összes lenyitása <FontAwesomeIcon icon="fa-solid fa-chevron-down" /></>)
                        } 
                </button>
            </div>
        )
    }

    const ToggleBlockAll = ({toggleAllTasks,allTasksOpen}) => {
        return (
                <button className="btn button" onClick={toggleAllTasks}>
                    {allTasksOpen 
                        ? (<>Összes bezárása <FontAwesomeIcon icon="fa-solid fa-chevron-up" /></>) 
                        : (<>Összes lenyitása <FontAwesomeIcon icon="fa-solid fa-chevron-down" /></>)
                        } 
                </button>
        )
    }    

    return (
        <div>
            {renderHead()}
            {!table ? (
                <>
                {/* Keresési mező és a feladatok listázása */}
                {console.log('SSSSSSSSSSSSSSSSSSSSSSSSSS')}
                {console.log(filteredTasks)}
                {<input className={'search-input my-2'} onChange={(e) => setSearchKey(e.target.value)} type="text" placeholder={'Keresés...'} />}

                <Row className='search-filter-container-compact mb-2'>
                    <div className="filter col-4">
                        <TaskFilterOnly
                            order={order}
                            setOrder={setOrder}
                            isDoneFilter={isDoneFilter}
                            setIsDoneFilter={setIsDoneFilter}
                            />
                    </div>
                    <div className="filter col-8 text-end">
                        {<ToggleBlockAll toggleAllTasks={toggleAllTasks} allTasksOpen={allTasksOpen} ></ToggleBlockAll>}
                    </div>
                </Row>
                
                <Row>
                    {filteredTasks.map((task) => (
                    <TaskCard
                        key={'task_' + task.id}
                        task={task}
                        isNebihSendable={isNebihSendable}
                        statusIcons={statusIcons}
                        isCompleted={isCompleted}
                        tableName={tableName}
                        redirectToTable={redirectToTable}
                        isOpen={taskStates[task.id] !== false}
                        toggleTaskState={toggleTaskState}
                    />
                    ))}
                    {!filteredTasks.length && <strong>Nincs a keresési feltételeknek megfelelő feladat!</strong>}
                </Row>
                </>
            ) : (
                <>
                {console.log('gggggggggggggggggggggggggg')}
                {console.log(filteredTasks)}                
                    {/* Van kiválasztott táblacsoport */}
                    {<TaskCardTable key={table.table_id} table={table} isOpen={tableStates[table.table_id] !== false} toggleTableState={toggleTableState} details={true} toggleButton={true} relatedParcels={relatedParcelNames} taskCount={filteredTasks.length} />}
                    {
                        <NoteBlock 
                            name="table" // fontos! ez meghatározza az API url végpontot is!
                            notes={table.notes} 
                            cardClass="task mb-3 mt-3 tablenotelist"
                            parentItem={table}
                            user={user}
                        />
                    }

                <TaskFilterBar
                    searchKey={searchKey}
                    setSearchKey={setSearchKey}
                    order={order}
                    setOrder={setOrder}
                    isDoneFilter={isDoneFilter}
                    setIsDoneFilter={setIsDoneFilter}
                    />

                    {<ToggleBlock toggleAllTasks={toggleAllTasks} allTasksOpen={allTasksOpen}  filteredTasks={filteredTasks} ></ToggleBlock>}
                    <TaskList 
                        tasks={filteredTasks} 
                        isNebihSendable={isNebihSendable} 
                        statusIcons={statusIcons} 
                        isCompleted={isCompleted} 
                        tableName={tableName} 
                        toggleTaskState={toggleTaskState} 
                        taskStates={taskStates} 
                        redirectToTable={redirectToTable} 
                        noResultsMessage="Jelenleg nincs faladat ehhez a táblacsoporthoz" />
                </>
            )}

            {/* <div className="float-button" onClick={() => navigate(table ? `/new-task/${table.table_id}` : "/new-task")}>
                <FontAwesomeIcon icon="plus-circle" />
            </div> */}
        </div>
    );
};

export default TableTask;
